import { forwardRef, Provider } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";

const createControlValueAccessorProvider = <T extends any>(type: T): Provider => ({
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => type),
  multi: true,
})

export default createControlValueAccessorProvider
